let bOffersLoaded = false; /**WEBMESS-540: boolean variable to determine if the Offers plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

export default function initOffers(config, GenesysJS) {
  if (!bOffersLoaded) {
    bOffersLoaded = true;
    GenesysJS.log('Loading OffersHelper plugin');
    Genesys('loadPlugin', 'OffersHelper');
  }
}
